import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
    AbstractModalComponent,
    AbstractModalData,
    ModalType,
} from '@connect-services/client/components/abstract-modal/abstract-modal.component';
import { ModalResultEnum } from '@connect-services/client/models/common.model';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

export type ModalData = {
    cancelLabel?: string;
    confirmLabel: string;
} & AbstractModalData;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-modal',
    templateUrl: './modal.component.html',
})
export class ModalComponent extends AbstractModalComponent {
    public override data: ModalData = inject(MAT_DIALOG_DATA);
    public dialogRef = inject(MatDialogRef<ModalComponent>);

    protected readonly ButtonType = ButtonType;
    protected readonly ModalResultEnum = ModalResultEnum;
    protected readonly ModalType = ModalType;

    public constructor() {
        super();
    }

    public onClick(result: ModalResultEnum): void {
        this.dialogRef.close(result);
    }
}
